export default {
    index: {
        home: '首页',
        meetingCountdown: '距离会议开始还有',
        importantEvents: '重要时间',
        contactUs: '联系我们',
        Day: '天',
        Hour: '时',
        Minute: '分',
        Second: '秒',
        Organizer: '组织机构'

    }
}